type CsvJson = {
  headers: string[];
  body: string[][];
};

const STAFF_ATTENDANCE_HEADERS: string[] = [
  'Code',
  'Email',
  ...Array.from({ length: 31 }, (_, i) => String(i + 1))
];

const INITIAL_STATUSES: string[] = [
  'A',
  'P',
  'P',
  'P',
  'P',
  'A',
  'P',
  'P',
  'P',
  'P',
  'P',
  'P',
  'P'
];

const getStaffAttendanceSampleBody = (): string[][] => {
  const dayValues = [
    ...INITIAL_STATUSES,
    ...Array(31 - INITIAL_STATUSES.length).fill('')
  ];

  return [['1033', 'test@test.com', ...dayValues]];
};

const getStaffAttendanceSample = (): CsvJson => ({
  headers: STAFF_ATTENDANCE_HEADERS,
  body: getStaffAttendanceSampleBody()
});

export { getStaffAttendanceSample };